
jQuery(document).ready(function ($) {
    var galleries = $('.wp-block-gallery ');
    if (galleries.length) {
        galleries.each(function (index, item) {
            var domTrigger = $('<button class="text-title show-gallery btn-suspended mb-5">View Gallery</button>')

            domTrigger.appendTo(item)
        })
    }

    $(document).on('click', '.show-gallery', function () {
        $('.gallery ul li').remove();
        $('.gallery').addClass('open');
        $(this).prev('.blocks-gallery-grid').find('li').each(function (index) {
            var imgSrc = $(this).find('img').attr('src');

            var imgListItem = $('<li data-index="' + index + '"><img src="' + imgSrc + '"></li>');
            imgListItem.appendTo('.gallery ul');

            gallery()
        });
    })

    function gallery() {
        var index = 0;
        var active = 'gallery-item-active';
        var itemsCount = $('.gallery li').length - 1;

        $('.gallery li[data-index="0"]').addClass(active);

        $(document).on('click', '.gallery-close', function () {
            $('.gallery').removeClass('open');
            $('.' + active).removeClass(active)
        })

        $(document).on('click', '.gallery-next', function () {
            $('.' + active).removeClass(active);
            index = index == itemsCount ? 0 : index + 1;
            $('.gallery li[data-index=' + index + ']').addClass(active);
        });

        $(document).on('click', '.gallery-previous', function () {
            $('.' + active).removeClass(active);
            index = index == 0 ? itemsCount : index - 1;
            $('.gallery li[data-index=' + index + ']').addClass(active);
        });
    }
});